export const overflowScrollbarStyles = {
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },

  // Track styles
  '&::-webkit-scrollbar-track': {
    background: 'var(--chakra-colors-bg-muted)',
    borderRadius: '4px',
  },

  // Thumb styles
  '&::-webkit-scrollbar-thumb': {
    background: 'var(--chakra-colors-border-emphasis)',
    borderRadius: '4px',
  },

  // Hover styles for enhanced visibility
  '&::-webkit-scrollbar-thumb:hover': {
    background: 'var(--chakra-colors-border-active)',
  },
};
